import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';

import { Field, reduxForm } from 'redux-form';

import SwitchOffers from '../../../shared/switch';
import checkIsExcludedCountryCode from '../../../shared/checkIsExcludedCountryCode';

import OffersSearchField from './search-field';
import SelectField from '../../../shared/form-elements/multiselect/select';
import CheckBoxField from '../../../shared/form-elements/checkbox';

import './../../../../../shared/flags/flag-icon-base.less';

lessRequire('modules/offers/components/filters/main.less');
lessRequire('modules/offers/components/filters/select-field.less');
lessRequire('modules/offers/components/filters/checkbox-field.less');

const isEverad = process.env.CPA_ENV === 'everad';

const Form = props => {
	const { handleSubmit, applyFilters, reset, resetFilters, intl, formData, userIsMaster } = props;

	const onSubmit = handleSubmit(d => applyFilters(d));

	return (
		<form action="#" onSubmit={onSubmit} className="offer-filters__half-width">
			<div className="offer-filters__search">
				<h2 className="font-proxima-nova-bold">{ props.intl('Офферы') }</h2>
				<SwitchOffers links={props.switchControlConfig} intl={props.intl}/>
				<Field name="offersSearch" component={OffersSearchField} onSubmitForm={onSubmit} intl={intl}/>
			</div>

			<div className="offer-filters__select-group">
				<Field
					name="category"
					className="offer-select-control"
					placeholder={intl('Категория')}
					component={SelectField}
					options={formData['categoryOptions']}
					multi={true}
				/>

				<Field
					name="geo"
					className="offer-select-control"
					placeholder={isEverad ? intl('Таргетинг') : intl('Гео')}
					component={SelectField}
					searchable={true}
					options={getCountriesOptions(formData['geoOptions'])}
					multi={true}
				/>

				{isEverad && userIsMaster && (
					<Field
						name="childAffiliates"
						className="offer-select-control child-affiliates"
						placeholder={intl('Вебмастера')}
						component={SelectField}
						options={formData['childAffiliatesOptions']}
						multi={true}
					/>
				)}

				{isEverad && (
					<div className="offer-filters__checkbox-container">
						<div className="offer-filters__checkbox-group offer-filters__checkbox-group--equel first-item">
							<Field
								name="isNew"
								className="offers-filters__row-checkbox"
								labelText={intl('Новые')}
								component={CheckBoxField}
							/>
							{/*<Field*/}
							{/*	name="isExclusive"*/}
							{/*	className="offers-filters__row-checkbox"*/}
							{/*	labelText={intl('Авторский')}*/}
							{/*	remark={intl('Создано в Everad')}*/}
							{/*	component={CheckBoxField}*/}
							{/*/>*/}
							<Field
								name="isOwnCallcenter"
								className="offers-filters__row-checkbox"
								labelText={intl('Свой Колл-Центр')}
								component={CheckBoxField}
							/>
							<Field
								name="isContestEnabled"
								className="offers-filters__row-checkbox"
								labelText={intl('Конкурсные')}
								component={CheckBoxField}
							/>
						</div>
						{/*<div className="offer-filters__checkbox-group">*/}
						{/*	<Field*/}
						{/*		name="isOwnCallcenter"*/}
						{/*		className="offers-filters__row-checkbox"*/}
						{/*		labelText={intl('Свой колл- центр')}*/}
						{/*		component={CheckBoxField}*/}
						{/*	/>*/}
						{/*	<Field*/}
						{/*		name="isContestEnabled"*/}
						{/*		className="offers-filters__row-checkbox"*/}
						{/*		labelText={intl('Конкурсные')}*/}
						{/*		component={CheckBoxField}*/}
						{/*	/>*/}
						{/*</div>*/}
					</div>
				)}

				<div className="offers-filters__submit">
					<button className="button yellow-btn font-proxima-nova-semibold apply-btn" type="submit">
						{intl('Применить фильтр')}
					</button>
					<button
						className="reset-btn"
						onClick={() => {
							reset();
							resetFilters();
						}}
						type="button"
					/>
				</div>
			</div>
		</form>
	);
};

Form.propTypes = {
	handleSubmit: PropTypes.func,
	applyFilters: PropTypes.func,
	reset: PropTypes.func,
	resetFilters: PropTypes.func,
	intl: PropTypes.func,
	formData: PropTypes.object,
	switchControlConfig: PropTypes.array,
	userIsMaster: PropTypes.bool
};

const getCountriesOptions = options => {

	const sortedOptions = options
		.sort((prev, current) =>  (prev.label > current.label) ? 1 : -1)
		.filter(option => !checkIsExcludedCountryCode(option.countryCode));

	return sortedOptions.map(option => ({
		...option,
		className: `flag-icon-${option.countryCode.toLowerCase()} flag-positioning`
	}));
};

export default reduxForm({
	form: 'offerFilters'
})(Form);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/filters/main.js